<template>
  <div class="moles-header__content dense--top">
    <h2 class="services__subtitle">
      Estos son los documentos que vas a obtener:
    </h2>
    <div class="services__items">
      <IncludedItem
        v-for="item in items"
        v-bind:key="item.title"
        :item="item"
      ></IncludedItem>
    </div>
    <h2 class="services__subtitle bottom">
      TRIOTECA te consigue el mejor precio.
    </h2>
  </div>
</template>
<script>
import IncludedItem from '@/web/services/IncludedItem';
import { getRelativePosition } from '@/lego/utils/dom/element';

export default {
  components: { IncludedItem },
  props: {},
  data() {
    return {
      items: [
        {
          title: 'Tasación oficial',
          icon: '/img/web/services/appraisal.svg',
          content:
            '<p>Es un trámite obligatorio que tiene por objetivo valorar un inmueble en un momento determinado para que la propiedad sea válida como garantía de un préstamo hipotecario por un plazo de 6 meses.</p>',
          cta: {
            title: 'Solicitar tasación',
            action: () => {
              const el = document.querySelector('.appraisal__form');
              const y = getRelativePosition(el).top - 92;
              window.scrollTo({ top: y, behavior: 'smooth' });
            },
          },
        },
        {
          title: 'Nota simple',
          icon: '/img/web/services/registration.svg',
          content:
            '<p>El tasador necesita una Nota Simple actualizada de la vivienda para poder emitir el informe de tasación. Comprueba la coincidencia de la localización de la vivienda, las características descritas en el registro, el estado de ocupación y adecuación al Plan Urbanístico según el Registro y Catastro.</p>',
        },
        {
          title: 'Informe técnico jurídico',
          icon: '/img/web/services/certificate.svg',
          content:
            '<p>Antes de formalizar con el vendedor tu compromiso de compra, es necesario verificar la situación jurídica del inmueble según lo dispuesto en el Extracto expedido por el Registro de la Propiedad y el registro Catastral del inmueble. La finalidad es revisar que la vivienda está lista para ser comprada.</p>',
        },
        {
          title: 'Certificado catastral de valor de referencia',
          icon: '/img/web/services/euro.svg',
          content:
            '<p>Es el documento que indica el valor de referencia basándose en la información física, jurídica y económica de un inmueble, de carácter público y oficial.</p>',
        },
      ],
    };
  },
  computed: {},
  methods: {},
};
</script>
